/**
 * Update any specified input field value attributes, to ensure it's alwasy set.
 * Useful for updating CSS based on value.
 */

// inputValueUpdate :: String -> [Element]
function init(selector = '.value-update') {
    const inputs = [].slice.call(document.querySelectorAll(selector));
    return inputs.map(i =>
        i.addEventListener('keyup', function() {
            if (this.value) {
                this.setAttribute('value', this.value);
                this.setAttribute('data-value', this.value);
            } else {
                this.removeAttribute('value');
                this.removeAttribute('data-value');
            }
        })
    );
}

export default { init };
